// Single source of truth for SuperTechLED's public business details.
// Footer, Contact page, emails and schema all read from here.
export const BUSINESS = {
  name: "SuperTechLED",
  email: "supertechled@outlook.com",
  phone: "0413 611 809",
  abn: "72 839 602 047",
  address: "Brisbane, QLD, Australia",
};

// Grow guide author byline — bioShort on guide pages, full bio on About.
export const AUTHOR = {
  name: "Dave Mills",
  bioShort:
    "30+ years growing hydroponically, 20+ years running his own hydroponics store, and 14 years designing and researching grow light spectrums. Regarded in the industry as a master grower, Dave brings deep knowledge of plant biology, nutrition and LED technology to every product.",
  bio: [
    "For over 20 years he has owned and run his own hydroponics store, helping thousands of growers, from first-timers to commercial operators, get the best from their gardens. His knowledge covers every part of the craft: plant biology, plant nutrition, growing environments and the fine-tuning that separates a good harvest from a great one.",
    "For the past 14 years, Dave has focused on grow light design and research, running his own R&D into light spectrums and how plants respond to them. That work has given him deep scientific knowledge of light and its effect on plant growth, backed by practical expertise in LED components and repair. It's this rare mix of grower's instinct and technical knowledge that goes into every product we design.",
    "When you buy from us, you're not just buying equipment. You're getting three decades of real-world growing experience and the backing of someone who knows plants and lights inside out.",
  ],
};
